import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Vue from 'vue';
import { Collapse } from 'bootstrap';
import Vuelidate from 'vuelidate';
import { i18n } from './core/lang/core.i18n';
import { coreRouter } from './core/core.router';
import Core from './core/core.vue';
import VueRouter from 'vue-router';
import { EdContextMenu } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import EdEventBus from '@/plugins/ed-event-bus/ed-event-bus';
import { EdModal } from '@/plugins/ed-modal/ed-modal.plugin';
import { EdToast } from '@/plugins/ed-toast/ed-toast.plugin';
import { EdSocket } from '@/plugins/ed-socket/ed-socket.plugin';
import VueResize from 'vue-resize';
import { ContentFilters } from '@/content/filters/content.filters';
import VueYoutube from 'vue-youtube';
import { FilesCache } from '@/shared/plugins/files-cache/files-cache.plugin';
import { BuilderCache } from './shared/plugins/files-cache/builder-cache.plugin';
import { Store } from './core/store/core.store';
import { CoreModule } from './core/core.module';
import { SplashScreen } from './shared/plugins/splash-screen/splash-screen.plugin';
import SessionMixin from './core/mixins/session.mixin';
import { CoreComponents } from '@/core/components/core.components';
import { CoursesComponents } from '@/courses/components/courses-components';
import { commonComponents } from '@/components/common.components';
import { Layouts } from '@/layouts/layouts.components';
import ContentComponents from '@/content/components/content-components';
import { CourseTemplateComponents } from '@/course-templates/components/course-templates.components';
import ToolService from '@/providers/tools';
import { EduacProvider } from './core/providers/eduac.provider';
import { BackupFileServices } from './core/services/backup.file.services';
import VueFlip from 'vue-flip';
import VueVirtualScroller from 'vue-virtual-scroller'
import { ShortDayNameFromList } from './shared/filters/short-day-name-from-list.filter';
import { Hour12 } from './shared/filters/hour-12.filter';
import { HideForRoleDirective } from './auth/directives/hide-for-role.directive';

/* Import Webcat's web components */
import '@webcat/commons-web-components/dist/wc-calendar.component.bundle'; // <wc-calendar>
import '@webcat/commons-web-components/dist/wc-data-table.component.bundle'; // <wc-data-table> / <wc-pagination>
import '@webcat/commons-web-components/dist/wc-time-picker.component.bundle'; // <wc-time-picker>
import '@webcat/commons-web-components/dist/wc-calendar-time.component.bundle'; // <wc-calendar-time>
import { CacheData } from './shared/plugins/files-cache/cache.plugin';
import { ClickOutside } from './shared/directives/click-outside.directive';
import { Resize } from './shared/directives/resize.directive';



/* add plugins */
Vue.use(Vuelidate);
Vue.use(EdContextMenu);
Vue.use(VueRouter);
Vue.use(EdEventBus);
Vue.use(EdModal);
Vue.use(EdToast);
Vue.use(VueResize);
Vue.use(EdSocket);
Vue.use(VueYoutube);
Vue.use(SplashScreen);
Vue.use(CacheData);
Vue.use(FilesCache);
Vue.use(BuilderCache);
Vue.use(CoreModule);
Vue.use(VueFlip);
Vue.use(VueVirtualScroller);

Vue.config.productionTip = false;

// Treat wc tags as custom elements
Vue.config.ignoredElements = [/^wc-/];

// --- config eduacCustomErrorHandler starts ---
//references:
//https://www.raymondcamden.com/2019/05/01/handling-errors-in-vuejs
//https://stackoverflow.com/questions/52071212/how-to-implement-global-error-handling-in-vue
Vue.config.errorHandler = (error, instance, info) => {
  BackupFileServices.eduacCustomErrorHandler({vueError:{error, instance, info}});
  throw error;
};

window.onerror = function (msg, url, line, col, error) {
  BackupFileServices.eduacCustomErrorHandler({globalError:{msg, url, line, col, error}});

  // Handle chunk loading errors on deploy
  if (error.toString().includes('Unexpected token') || error.toString().includes('Loading chunk') || 
    msg.toString().includes('Unexpected token') || msg.toString().includes('Loading chunk' )) {

    // Prevent infinite reloads
    const reloadKey = 'chunk_error_reload_attempt';
    const reloadAttempts = sessionStorage.getItem(reloadKey) || 0;
    const reloadTimeKey = 'chunk_error_last_reload_time';

    const lastReloadTime = sessionStorage.getItem(reloadTimeKey) || 0;
    const currentTime = Date.now();
    const reloadCooldown = 5 * 60 * 1000;

    if (Number(reloadAttempts) < 2 || (currentTime - Number(lastReloadTime) > reloadCooldown)) {
      sessionStorage.setItem(reloadTimeKey, currentTime.toString());
      sessionStorage.setItem(reloadKey, (Number(reloadAttempts) + 1).toString());
      window.location.reload();
    }
  }
  throw error;
}

window.addEventListener('unhandledrejection', (promiseRejectionEvent) => {
  BackupFileServices.eduacCustomErrorHandler({promiseRejectionEvent});
});
// --- config eduacCustomErrorHandler ends ---


const vue = new Vue({
  render: h => h(Core),
  i18n,
  mixins: [SessionMixin],
  router: coreRouter,
  store: Store,
  directives: {
    HideForRoleDirective,
    ClickOutside,
    Resize,
  },
  components: {
    ...CoreComponents,
    ...commonComponents,
    ...Layouts,
    ...ContentComponents,
    ...CoursesComponents,
    ...CourseTemplateComponents
  },
  filters: {
    ['ContentTextFilter']: ContentFilters.ContentTextFilter, 
    ['ObjectIconFilter'] : ContentFilters.ObjectIconFilter,
    ShortDayNameFromList,
    Hour12,
  },
  beforeMount() {
    this.$FilesCache.checkAccess();
    this.$BuilderCache.checkAccess();
    let param: any = ToolService.getUrlParams(window.location.href);
    if(param && param.webview === 'true') {
      this.$App.Store.setHeaderVisible(false);
      this.$App.Store.setActiveWebwiew(true);
    } else {
      this.$App.Store.setHeaderVisible(true);
    }
  }
}).$mount('#eduac');

(EduacProvider.prototype as any).$vue = vue;

document.addEventListener('DOMContentLoaded', () => {
  const accordionElements: NodeListOf<Element> = document.querySelectorAll('.accordion-collapse');
  accordionElements.forEach((element) => {
    new Collapse(element, {
      toggle: false,
    });
  });
});
